const Navigation = [
    { name: 'Home', href: '/' },
    { name: 'YouTube', href: '/youtube-videos' },
    { name: 'Twitch', href: '/twitch-stream' },
    { name: 'Extra Life', href: '/extra-life' },
    /* { name: 'Articles', href: '/articles' }, */
    /* { name: 'About', href: '/' }, */
];

export default Navigation;